module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"secureEnvironment":"Ambiente Seguro"},"en-US":{"secureEnvironment":"Secure Environment"}}')
  delete Component.options._Ctor
}
